<template>
  <div>
    <el-form
      label-width="60px"
      ref="form"
      :model="form"
      label-position="right"
      size="mini"
    >
      <el-form-item label="日期：">
        <el-date-picker
          v-model="form.dateRange"
          type="daterange"
          :clearable="false"
          placeholder="选择日期"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          :picker-options="dateRangePickerOptions"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="渠道：" prop="channelId">
        <channel-selector
          :enable-full-channels="true"
          placeholder="请选择"
          @ready="onChannelSelectorReady"
          @change="onChannelSelectorChange"
          ref="channelSelector"
        >
        </channel-selector>
      </el-form-item>
      <el-form-item label="来源：" prop="source">
        <source-selector
          :enable-all="true"
          placeholder="请选择"
          @ready="onSourceSelectorReady"
          @change="onSourceSelectorChange"
          ref="sourceSelector"
        >
        </source-selector>
      </el-form-item>      
      <el-form-item>
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="loadList()"
          style="margin-left: 10px"
          >查询</el-button
        >
      </el-form-item>
    </el-form>

    <el-table
      :data="list"
      border
      size="small"
      style="width: 301px"
      height="600px"
    >
      <el-table-column
        fixed="left"
        prop="date"
        label="日期"
        align="center"
        width="100"
      >
      </el-table-column>
      <el-table-column
        fixed="left"
        prop="number"
        label="创角数量"
        align="center"
        width="200"
      >
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";
const dialogutil = require("@/dialogutil");
import ChannelSelector from "@/components/ChannelSelector";
import SourceSelector from "@/components/SourceSelector";
import { DateTime } from "luxon";

export default {
  data() {
    return {
      dateRangePickerOptions: {
        disabledDate: this.disabledDate,
      },

      list: [], //

      form: {
        channelId: "",
        source: "",
        dateRange: [
          DateTime.now().minus({"days": 6}).toFormat("yyyy-MM-dd"),
          DateTime.now().toFormat("yyyy-MM-dd"),
        ],
      },
    };
  },
  components: {
    ChannelSelector,
    SourceSelector,
  },
  async created() {},

  methods: {
    async onChannelSelectorReady() {
      this.$refs.channelSelector.channelId = this.form.channelId;
    },

    async onChannelSelectorChange(newChannelId, oldChannelId) {
      this.form.channelId = newChannelId;
    },

    async onSourceSelectorReady() {
      this.$refs.sourceSelector.source = this.form.source;
    },

    async onSourceSelectorChange(newSource, oldSource) {
      this.form.source = newSource;
    },

    disabledDate(date) {
      console.log(date);
      return date > DateTime.now();
    },

    /**
     *
     */
    async loadList() {
      if (this.form.channelId === "") {
        this.$message.error("请选择渠道");
        return;
      }

      if (this.form.source === "") {
        this.$message.error("请选择来源");
        return;
      }

      this.list = [];
      this.maxDiffDay = 0;
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/reportForms/queryDailyPlayers`,
          {
            fromDate: this.form.dateRange[0],
            toDate: this.form.dateRange[1],
            channel: this.form.channelId,
            source: this.form.source,
          },
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message.error(resData.message);
        return;
      }

      let listInResponse = resData.data.dailyEntries || [];

      for (let e of listInResponse) {
        this.list.push({
          date: e.date,
          number: e.number,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-table__row td {
  padding: 0px 0;
}

.link-button {
  padding-left: 5px;
  padding-right: 5px;
  color: rgb(37, 148, 240);

  cursor: pointer;
}
</style>